// extracted by mini-css-extract-plugin
module.exports = {"layout":"_c3ddf4d","header":"_1772d52","main":"_893e0fe","betSlipHidden":"_2b821e8","betSlipOpen":"_f840e89","headerBetSlipOpen":"_f5d0d65"};